import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';
import { useParams } from 'react-router-dom';
import { Book } from 'lucide-react';

const SharedAlbum = () => {
  const { shareToken } = useParams();
  const [data, setData] = useState(null);
  const [images, setImages] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSharedAlbum();
  }, [shareToken]);

  const fetchSharedAlbum = async () => {
    try {
      const response = await axios.get(`${API}/share/${shareToken}`);
      setData(response.data);
    } catch (error) {
      console.error('Failed to load shared album');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-amber-50 via-rose-50 to-blue-50">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-amber-50 via-rose-50 to-blue-50">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Album not found</h2>
          <p className="text-gray-600">This album may be private or the link is invalid</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-rose-50 to-blue-50">
      <header className="bg-white/60 backdrop-blur-sm border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-center">
          <Book className="w-12 h-12 text-amber-600 mx-auto mb-3" />
          <h1 className="text-3xl font-bold text-gray-900">{data.album.title}</h1>
          {data.album.description && (
            <p className="text-gray-600 mt-2">{data.album.description}</p>
          )}
          <p className="text-sm text-gray-500 mt-1">{data.photos.length} photos</p>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="photo-grid">
          {data.photos.map(photo => (
            <div key={photo.id} className="bg-white rounded-lg overflow-hidden border border-gray-200 hover-lift">
              <div className="relative aspect-square">
                <img 
                  src={`${API}/share/${shareToken}/photos/${photo.id}/image?thumbnail=true`} 
                  alt={photo.caption} 
                  className="w-full h-full object-cover bg-gray-200"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <p className="text-sm text-gray-900 font-medium mb-1">{photo.caption || photo.filename}</p>
                {photo.location && <p className="text-xs text-gray-600 mb-1">{photo.location}</p>}
                {photo.original_date && <p className="text-xs text-gray-500">{photo.original_date}</p>}
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default SharedAlbum;
